import React, { useState } from 'react';
import { Tabs } from 'antd';
import moment from "moment";

import EventForm from './EventForm';

const { TabPane } = Tabs;

const defaultPlaceholderImage = "https://firebasestorage.googleapis.com/v0/b/implant-compare.appspot.com/o/images%2Fplaceholder.png?alt=media&token=18740d81-a9cd-4c0c-b98e-8f93cb4fa52c"

const newEventDefault = {
  title: 'New Event',
  type: "Surgeries",
  date: moment(new Date()).add(1,'days'),
  // author: '',
  description: '',
  liked_users: [],
  isUpcoming: true,
  notificationSent: false,
  notificationPeriod: "afternoon",
  tags: [],
  thumbnail: defaultPlaceholderImage
};

const newPastEventDefault = {
  title: 'New Past Event',
  type: "Surgeries",
  date: moment(new Date()).subtract(2,'days'),
  // author: '',
  description: '',
  liked_users: [],
  isUpcoming: false,
  notificationSent: true,
  youTubeUrl: '',
  tags: [],
  thumbnail: defaultPlaceholderImage
};

const Content = ({
  eventId,
  events,
  channels,
  userClaims
}) => {
  const [newEvent, setNewEvent] = useState(true);

  const saveNewEvent = () => {
    setNewEvent(false);
  };

  let ownChannel = [];

  if (userClaims.userType === "Contributor") {
    ownChannel = channels && channels.filter(channel => {
      if (channel.ownerId && channel.ownerId.length > 0) {
        let isArray = Array.isArray(channel.ownerId)

        return isArray && channel.ownerId.find(id => {
          if (id === userClaims.user_id) {
            return channel
          }
        })
      }
    })
  }
  
  let eventEdit = {};
  if (eventId && events) {
    eventEdit = events.find(event => event.id === eventId)
  }

  return (
    <Tabs
      defaultActiveKey={eventId && eventEdit ? '0' : '1'}
      className="create-panels"
    >
      {
        (eventId && eventEdit) && (
          <TabPane tab="Edit Event" key="0">
            <div className="tab-content">
              <div className="container">
                <EventForm
                  newElement={false}
                  item={eventEdit}
                  ownChannel={ownChannel}
                  channelsList={channels}
                  userClaims={userClaims}
                  saveNewEvent={saveNewEvent}
                />
              </div>
            </div>
          </TabPane>
        )
      }
      <TabPane tab="New Event" key="1">
        <div className="tab-content">
          <div className="container">
            <EventForm
              newElement={true}
              item={newEventDefault}
              ownChannel={ownChannel}
              channelsList={channels}
              userClaims={userClaims}
              saveNewEvent={saveNewEvent}
            />
          </div>
        </div>
      </TabPane>
      <TabPane tab="Upload Past Event" key="2">
        <div className="tab-content">
          <div className="container">
            <EventForm
              newElement={true}
              item={newPastEventDefault}
              ownChannel={ownChannel}
              channelsList={channels}
              userClaims={userClaims}
            />
          </div>
        </div>
      </TabPane>
    </Tabs>
  );
};

export default Content;


// WEBPACK FOOTER //
// ./src/pages/EventEditor/Content/index.js